import React, { useState } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import contactImage from '../media/contactus.jpg'; // Replace with your actual path
import NNavbar from './navbar'; 
import Footer from './footer';
import '../styles/contactus.css'; // Import your CSS styles
import { ToastContainer, toast,Bounce } from 'react-toastify';

const ContactUs = () => {
   const [formData, setFormData] = useState({
          client_name: '',
          client_email: '',
          client_phone: '',
          service_required: '',
          message: '',
    });

    const [disabled, setDisabled] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async(e) => {
    e.preventDefault();
    // console.log('Submitted Data:', formData);
    try {
            setDisabled(true);
            formData.p_id = '1005'  
          const res = await fetch('https://commandx-backend.vercel.app/mail/contactmail', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            
            body: JSON.stringify(formData),
          });
    
          if (res.ok) {
            setDisabled(false);
            toast.success('Your message has been sent!', {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                transition: Bounce,
                });
            setFormData({ client_name: '', client_email: '', client_phone: '', message: '' });
          } else {
            setDisabled(false);
            toast.error('Failed to send message!', {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                transition: Bounce,
                });
          }
        } catch (err) {
          //console.error('Error sending message:', err);
          setDisabled(false);
          toast.error('Failed to send message!', {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
            });
        }
    setFormData({ client_name: '', client_email: '', message: '' });
  };

  return (
    <>
    <NNavbar />
    <section className="contact-section">
      <div className="contact-header">
        <img src={contactImage} alt="Contact Support" className="img-fluid w-100" />
      </div>

      <Container className="py-5">
        <Row className="align-items-start">
          <Col md={6} className="mb-4 contact-content">
            <h2 className="contact-title">
              Get in touch <span style={{"color":"#2e3192"}}>with us</span>
            </h2>
            <p className="text-muted">
              Thanks for stopping by! Whether you have a question, comment or just want to say hi, don't be a stranger. We're here to help and we love connecting with our community.
            </p>
            <p>Drop us a line or use the<br/>contact form below to get in touch.</p>
            <div className="contact-info">
              <p><strong>Chat to us</strong><br />info@qplusmc.com</p>
              <p><strong>Call us</strong><br />+971 55 619 7770<br />+971 55 612 7770</p>
              <p><strong>Address</strong><br />Q Plus Management Consultancy (FZC)<br />Sharjah Research Technology and Innovation Park, Sharjah, UAE</p>
            </div>
          </Col>

          <Col md={6}>
            <Form onSubmit={handleSubmit} className="contact-form">
              <Form.Group className="mb-3">
                <Form.Control
                  type="text"
                  name="client_name"
                  placeholder="Full Name"
                  value={formData.client_name}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Control
                  type="email"
                  name="client_email"
                  placeholder="Email"
                  value={formData.client_email}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Control
                  as="textarea"
                  name="message"
                  placeholder="Your message"
                  rows={5}
                  value={formData.message}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <div className="text-end">
                <Button type="submit" disabled={disabled} className="contact-btn-page">Send Message</Button>
              </div>
            </Form>
          </Col>
        </Row>
      </Container>
    </section>
    <Footer />
    <ToastContainer
                    position="bottom-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick={false}
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                    transition={Bounce}
    />
    </>
  );
};

export default ContactUs;
